var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlackFundCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4688 2.5625H1.46875C1.19219 2.5625 0.96875 2.78594 0.96875 3.0625V13.0625C0.96875 13.3391 1.19219 13.5625 1.46875 13.5625H14.4688C14.7453 13.5625 14.9688 13.3391 14.9688 13.0625V3.0625C14.9688 2.78594 14.7453 2.5625 14.4688 2.5625ZM13.8438 12.4375H2.09375V3.6875H13.8438V12.4375ZM3.54844 11.1516C3.59688 11.2 3.67656 11.2 3.725 11.1516L6.42031 8.45625L8.20781 10.2453C8.25625 10.2938 8.33594 10.2938 8.38437 10.2453L13.025 5.60156C13.0734 5.55312 13.0734 5.47344 13.025 5.425L12.45 4.85C12.4265 4.82674 12.3948 4.81369 12.3617 4.81369C12.3287 4.81369 12.2969 4.82674 12.2734 4.85L8.29688 8.82812L6.50938 7.03906C6.48588 7.0158 6.45416 7.00275 6.42109 7.00275C6.38803 7.00275 6.35631 7.0158 6.33281 7.03906L2.975 10.3984C2.95174 10.4219 2.93869 10.4537 2.93869 10.4867C2.93869 10.5198 2.95174 10.5515 2.975 10.575L3.54844 11.1516Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFundCc);
export default __webpack_public_path__ + "static/media/black-fund-cc.dad921c7c590045badddd2f93665c6d1.svg";
export { ForwardRef as ReactComponent };